import React, { JSXElementConstructor, ReactElement } from 'react';
import i18n from 'i18next';

/**
 * Tries to translate a 'namespace:key' in the current the translation store.*
 * @param namespaceAndKey Namespace:key
 * @param translateOptions
 * @param defaultValue either a given value or null
 * @returns translated string
 */
export function tryTranslate(namespaceAndKey: string): string | null;
export function tryTranslate(namespaceAndKey: string, translateOptionas: any): string | null;
export function tryTranslate(namespaceAndKey: string, translateOptions: any | null, defaultValue: string): string;
export function tryTranslate(
  namespaceAndKey: string,
  translateOptions: any | null = null,
  defaultValue: string | null = null
) {
  return i18n.exists(namespaceAndKey) ? i18n.t(namespaceAndKey, translateOptions) : defaultValue;
}

export function translateWithCustomTransMarker(
  translation: string
): ReactElement<any, string | JSXElementConstructor<any>> {
  // custom marker -> $Trans("wrap me with", <span>)
  const marker = /\$Trans\(.*?\)/;
  // String inside (), use group[1] to get without " marks
  const markerTranslation = /"([^"]*)"/;
  // Component inside (), use group[1] to get without < marks
  const markerComponent = /<([^<>]*)>/;

  const matchedMarker = translation.match(marker);
  if (matchedMarker) {
    const matchMarkerTranslation = matchedMarker[0].match(markerTranslation);
    const matchMarkerComponent = matchedMarker[0].match(markerComponent);

    if (matchMarkerTranslation && matchMarkerComponent) {
      const stringToWrap = matchMarkerTranslation[1];
      const ComponentFromCustomMarker = matchMarkerComponent[1];

      const markerWhiteList = ['abbr'];
      if (!markerWhiteList.includes(ComponentFromCustomMarker)) {
        throw new Error('Invalid Custom Trans Marker: Component not allowed');
      }

      const markerSurroundingParts = translation.split(marker);
      return (
        <>
          {markerSurroundingParts[0]}
          {React.createElement(ComponentFromCustomMarker, {}, stringToWrap)}
          {markerSurroundingParts[1]}
        </>
      );
    }
  }

  // need to convert string to ReactElement
  return <>{translation}</>;
}
